export * from './incident-details.component';
